import React, { useEffect, useState } from "react";
import MainModal from "components/ModalMain";
import Button from "components/Button";
import VerificationInputField from "components/VerificationInputField";
import ModalNewEmailAddress from "screens/ModalNewEmailAddress";
import { useMutation } from "@apollo/client";
import { STAFF_CONTACT_CHANGE_SEND_CURRENT_OTP, VERIFY_CURRENT_ACCOUNT } from "graphql/service";
import { Head, Container, Footer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const ModalChangeEmailAddress = ({
  hidden,
  buttonStyle,
  refetch,
  email
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const [newEmailIsOpen, setNewEmailIsOpen] = useState(false);
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationCodeError, setVerificationCodeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [staffContactChangeSendCurrentOtp] = useMutation(STAFF_CONTACT_CHANGE_SEND_CURRENT_OTP, {
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message;
        if (error.message.includes("Validation")) {
          content = JSON.stringify(
            error.graphQLErrors[0]?.extensions?.exception
          );
        }
        debouncedErrorMessage(content);
      }
    },
  })

  const [verifyCurrentAccount, { data, loading }] = useMutation(VERIFY_CURRENT_ACCOUNT, {
    onCompleted: () => {
      setIsOpen(false);
      setNewEmailIsOpen(true);
      setVerificationCode("");
      setVerificationCodeError(false);
    },
    onError: (error) => {
      setVerificationCodeError(true);
      let messages = [];

      if (error.graphQLErrors?.length > 0) {
        messages = error.graphQLErrors.map(err => err.message);
      } else if (error.networkError?.result?.errors) {
        messages = error.networkError.result.errors.map(err => err.message);
      } else if (error.networkError) {
        messages = [error.networkError.message];
      }

      if (messages?.length > 0) {
        setErrorMessage(messages.join(", "));
      }
    }
  })

  const handleContinue = () => {
    if (verificationCode.length !== 6) {
      setVerificationCodeError(true);
      return;
    }
    verifyCurrentAccount({
      variables: {
        input: {
          contactType: "EMAIL",
          code: verificationCode.join(''),
        },
      },
    });
  };

  const handleSendVerificationCode = () => {
    staffContactChangeSendCurrentOtp({
      variables: {
        input: "EMAIL"
      },
    });
  };

  useEffect(() => {
    if (isOpen) {
      handleSendVerificationCode();
    }
  }, [isOpen]);

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setClose={() => {
          setIsOpen(false)
          setVerificationCode("")
          setVerificationCodeError(false)
          setErrorMessage("")
        }}
        className="modal-success"
        buttonLabel="Change Email"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }          
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Confirmation Required</Head>
        <Container>
          <div className="modalText">{`A verification code has been sent to your email address ${email}. Please enter the code below to continue:`}</div> 
          <VerificationInputField
            label="VERIFICATION CODE"
            isRequired
            width="320px"
            length={6}
            values={verificationCode}
            setValues={(values) => {
              setVerificationCode(values)
              setVerificationCodeError(false)
              setErrorMessage("")
            }}
            error={verificationCodeError}
            errorMessage={errorMessage}
            margin="16px 0 24px 0"
          />
          <Footer>
            <Button
              success
              additionalstyle={`
                width: 97px;
              `}
              onClick={handleContinue}
              data-loading={loading}
            >
              {loading ? null : "Continue"}
            </Button>
          </Footer>
          <div className="modalText">
            <span>{`Haven’t received the code? `}</span>
            <span
              className='highLight'
              onClick={handleSendVerificationCode}
            >
              Resend code
            </span>
          </div>
        </Container>
      </MainModal>
      <ModalNewEmailAddress
        isOpen={newEmailIsOpen}
        setIsOpen={setNewEmailIsOpen}
        refetch={refetch}
        token={data?.staffContactChangeConfirmCurrentOtp}
      />
    </>
  );
};

export default ModalChangeEmailAddress;
